import type {QueryAddressType} from 'actions/propertyActions'
import {FAKE_PID} from 'constants/appRoutesConstants'
import type {OpsOrderType} from 'types/orderTypes'
import {createPropertyAddress} from './addressServices'
// creates the link path to a product
export const getProductNavPath = (
  order: Pick<
    OpsOrderType,
    'pid' | 'productType' | 'productOrderId' | 'opsOrderId' | 'suppliedAddress'
  >
) => {
  const {pid = FAKE_PID, productType, productOrderId, opsOrderId, suppliedAddress} = order
  let path = ''

  if (productOrderId) {
    let productTypeInUrl
    if (productType === 'CDA_MLS') {
      productTypeInUrl = 'cda'
    } else {
      productTypeInUrl = productType.toLowerCase()
    }

    const query = getPathQuery(pid, createPropertyAddress(suppliedAddress))
    path = `/properties/${pid}/${productTypeInUrl}/${opsOrderId}${query}`
  }

  return path
}

export const getPropertyNavPath = (pid = FAKE_PID, address: QueryAddressType) => {
  const query = getPathQuery(pid, address)
  return `/properties/${pid}${query}`
}

export const getPathQuery = (pid: string, address?: QueryAddressType) => {
  let query = ''
  if (pid === FAKE_PID && address) {
    query = `?address=${encodeURIComponent(JSON.stringify(address))}`
  }
  return query
}
